export default "__VITE_ASSET__OHKgPmTD__"